import React from "react";
import MenuItem from "../../../commonComponents/MenuItem/MenuItem";
import "./carousel.css";

import CarouselSlider from "./CarouselSlider";

export default function CarouselComponent(props) {
  const menuItems = props.menuItems.map((val) => (
    <MenuItem key={val.ProductId} data={val} />
  ));

  return (
    <div className="carousel-container">
      <CarouselSlider
        fixedWidth={true}
        resetOnChange={props.resetPositionOnChange}
        responsive={true}
      >
        {menuItems}
      </CarouselSlider>
    </div>
  );
}
